/**
 * Read `inviteToken` from a signup or job-invite URL.
 *
 * Tech signup:  /signup?regionID={regionId}&inviteToken={token}
 * Job invite:   /open-jobs/{regionId}/{jobId}?inviteToken={token}
 *
 * The token is base64url of at least 32 bytes (43 characters, no padding).
 * Anything else is treated as absent so a bad query cannot be sent to the callable.
 */
export function inviteTokenFromSearch(search: string | null | undefined): string {
    const raw = new URLSearchParams(search || '').get('inviteToken');
    if (!raw) return '';
    const token = raw.trim();
    if (!/^[A-Za-z0-9_-]{43,}$/.test(token)) return '';
    return token;
}
